import React from 'react';

import PropTypes from 'prop-types';

export const MDash = ({ className }) => <span className={className}>&mdash;</span>;

MDash.propTypes = {
  className: PropTypes.string,
};

// Named export with casing variant for migration
export { MDash as Mdash };
